import axiosInstance from "../../../utils/axiosConfig";
import { compactParams } from "../../../lib/api/params";
import type { IsoDateRange } from "../../../lib/adminExport/datePresets";
import {
  ADMIN_SIGNUPS_DATA_URL,
  type AdminSignupUser,
  type AdminSignupsDataEnvelope,
  type SignupKycStatusFilter,
} from "../../../lib/api";

const EXPORT_PAGE_LIMIT = 100;
const MAX_EXPORT_PAGES = 200;

/** Walks every page of `/signups/data` for the filters currently on screen. */
export async function fetchSignupsForExport(filters: {
  range: IsoDateRange | null;
  search?: string;
  kycStatus?: SignupKycStatusFilter;
}): Promise<AdminSignupUser[]> {
  const users: AdminSignupUser[] = [];
  let totalPages = 1;

  for (let page = 1; page <= totalPages; page++) {
    if (page > MAX_EXPORT_PAGES) {
      throw new Error(
        `Export is limited to ${
          MAX_EXPORT_PAGES * EXPORT_PAGE_LIMIT
        } rows. Narrow the date range.`
      );
    }

    const { data } = await axiosInstance.get<AdminSignupsDataEnvelope>(
      ADMIN_SIGNUPS_DATA_URL,
      {
        params: compactParams({
          page,
          limit: EXPORT_PAGE_LIMIT,
          startDate: filters.range?.startDate,
          endDate: filters.range?.endDate,
          search: filters.search?.trim(),
          kycStatus: filters.kycStatus,
        }),
      }
    );

    const batch = Array.isArray(data?.data?.users) ? data.data.users : [];
    if (page === 1) {
      totalPages = Math.max(1, data?.data?.pagination?.totalPages ?? 1);
    }
    users.push(...batch);
    if (batch.length === 0) break;
  }

  return users;
}
